import ProjectDisciplinesConfigContent from './ProjectDisciplinesConfigContent'

export default ProjectDisciplinesConfigContent
